import { nsContract, nsNotifRules } from '@/app/i18n/namespaces';
import APPLICATIONS from '../../contracts/enums/ItpRegex';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    CONTRACT: {
        key: 'contract',
        type: 'tel',
        entity: 'keys.contract',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.contract',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    BANK_CODE: {
        key: 'bankCode',
        type: 'tel',
        entity: 'keys.bank_code',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.bank_code',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    RANK: {
        key: 'rank',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.rank',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.rank',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    RECIPIENT: {
        key: 'recipient',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.recipient',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.recipient',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    PARTNER: {
        key: 'partner',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.partner',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.partner',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    LEGAL_NAME: {
        key: 'legalName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.legal_name',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.legal_name',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    EVENT_TYPE: {
        key: 'eventType',
        type: FIELD_TYPES.TEXT,
        entity: 'push_payments_notif_rules',
        namespace: nsNotifRules
    },
    APPLICATION: {
        key: 'application',
        type: 'select',
        entity: 'keys.application',
        prefix: 'posTerminalApplication_',
        namespace: nsContract,
        filter: FILTER_TYPES.SELECT,
        enum: APPLICATIONS,
        enableSorting: true,
        sortOptions: true
    },
    EXTRA_1: {
        key: 'extra1',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.extra_1',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.extra_1',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    EXTRA_2: {
        key: 'extra2',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.extra_2',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.extra_2',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    LABEL: {
        key: 'label',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.label',
        namespace: nsNotifRules,
        placeholder: 'filter.placeholder.label',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    // handle errors upload files
    RULES_NOT_PROCESSED: {
        key: 'notProcessedRules',
        type: FIELD_TYPES.ARRAY,
        CONTRACT: {
            parentKeys: ['notProcessedRules'],
            key: 'contract',
            type: 'tel',
            namespace: nsNotifRules,
            entity: 'keys.contract'
        },
        BANK_CODE: {
            parentKeys: ['notProcessedRules'],
            key: 'bankCode',
            type: 'tel',
            namespace: nsNotifRules,
            entity: 'keys.bank_code'
        },
        RANK: {
            parentKeys: ['notProcessedRules'],
            key: 'rank',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.rank'
        },
        RECIPIENT: {
            parentKeys: ['notProcessedRules'],
            key: 'recipient',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.recipient'
        },
        PARTNER: {
            parentKeys: ['notProcessedRules'],
            key: 'partner',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.partner'
        },
        LEGAL_NAME: {
            parentKeys: ['notProcessedRules'],
            key: 'legalName',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.legal_name'
        },
        EVENT_TYPE: {
            parentKeys: ['notProcessedRules'],
            key: 'eventType',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'push_payments_notif_rules'
        },
        APPLICATION: {
            parentKeys: ['notProcessedRules'],
            key: 'application',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.application'
        },
        EXTRA_1: {
            parentKeys: ['notProcessedRules'],
            key: 'extra1',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.extra_1'
        },
        EXTRA_2: {
            parentKeys: ['notProcessedRules'],
            key: 'extra2',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.extra_2'
        },
        LABEL: {
            parentKeys: ['notProcessedRules'],
            key: 'label',
            type: FIELD_TYPES.TEXT,
            namespace: nsNotifRules,
            entity: 'keys.label'
        }
    }
};